import FakeDeviceApi from "./FakeDeviceApi";
import RealDeviceApi from "./RealDeviceApi";
import CommonRequestBodyDto from "../dto/common/CommonRequestBodyDto";
import DeviceSettingsSaveReqDto from "../dto/device/DeviceSettingsSaveReqDto";

class DeviceApi {
    fakeApi = false;
    fake = new FakeDeviceApi();
    real = new RealDeviceApi();

    getDeviceList = ({ shopCode }: { shopCode: string }) => {
        if (this.fakeApi) {
            return this.fake.getDeviceList();
        } else {
            return this.real.getDeviceList({ shopCode });
        }
    };

    getDeviceStatus = ({ shopCode }: { shopCode: string }) => {
        if (this.fakeApi) {
            return this.fake.getDeviceStatus();
        } else {
            return this.real.getDeviceStatus({ shopCode });
        }
    };

    getDeviceDetails = ({ idDevice }: { idDevice: number }) => {
        if (this.fakeApi) {
            return this.fake.getDeviceDetails();
        } else {
            return this.real.getDeviceDetails({ idDevice });
        }
    };

    getDeviceDetailsHistory = ({
        deviceId,
        page = 1,
        pageSize = 20,
    }: {
        deviceId: string;
        page?: number;
        pageSize?: number;
    }) => {
        if (this.fakeApi) {
            return this.fake.getDeviceDetailsHistory();
        } else {
            return this.real.getDeviceDetailsHistory({ deviceId, page, pageSize });
        }
    };

    getDeviceErrorList = ({
        storeId,
        startDay,
        endDay,
        deviceName,
        errorCode,
    }: {
        storeId: string;
        startDay: string;
        endDay: string;
        deviceName?: string;
        errorCode?: string;
    }) => {
        if (this.fakeApi) {
            return this.fake.getDeviceErrorList();
        } else {
            return this.real.getDeviceErrorList({ storeId, startDay, endDay, deviceName, errorCode });
        }
    };

    saveDeviceSettings = ({
        deviceId,
        reqDto,
    }: {
        deviceId: number;
        reqDto: CommonRequestBodyDto<DeviceSettingsSaveReqDto>;
    }) => {
        if (this.fakeApi) {
            return this.fake.saveDeviceSettings();
        } else {
            return this.real.saveDeviceSettings({ deviceId, reqDto });
        }
    };

    getDeviceSettings = ({ deviceId }: { deviceId: number }) => {
        if (this.fakeApi) {
            return this.fake.getDeviceSettings();
        } else {
            return this.real.getDeviceSettings({ deviceId });
        }
    };

    getSubDevice = ({ subDeviceId }: { subDeviceId: string }) => {
        if (this.fakeApi) {
            return this.fake.getSubDevice();
        } else {
            return this.real.getSubDevice({ subDeviceId });
        }
    };

    getSubDeviceByStore = ({ storeId, deviceId }: { storeId: string; deviceId: string }) => {
        if (this.fakeApi) {
            return this.fake.getSubDeviceByStore();
        } else {
            return this.real.getSubDeviceByStore({ storeId, deviceId });
        }
    };
}

export default DeviceApi;
